import { chartThemeValidator } from '../colorPicker/chartThemeValidator';

// eslint-disable-next-line func-names
export const dataToColors = function (data, colorsArray) {
  // Significa que o tema de cores deve ser resetado
  if (!colorsArray.length || !data) {
    return {};
  }

  const consistentColorsArray = chartThemeValidator(colorsArray, data.length);
  const parsedData = data.map((dataItem, dataIndex) => ({
    [dataItem.enunciado ? dataItem.enunciado : dataItem.name]: consistentColorsArray[dataIndex],
  })).reduce((prev, curr) => ({ ...prev, ...curr }), {});

  if (typeof parsedData === 'object') {
    return parsedData;
  }

  return null;
};
